import {
  Badge,
  Box,
  Button,
  Center,
  createStyles,
  Skeleton,
  Text,
} from "@mantine/core";
import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import DocumentNotificationCard from "./DocumentActions";
import { decrypt } from "../../../utils";
import { useDisclosure } from "@mantine/hooks";
import PendingActionsDrawer from "./PendingActionsDrawer";

const useStyles = createStyles(() => ({
  container: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "5px",
    display: "flex",
    flexDirection: "column",
    // height: "100vh",
    height: "1000px",
    overflowY: "auto",
    gap: "1rem",
    // Adding scrollbar styles
    scrollbarWidth: "thin",
    scrollbarColor: "#E5E5E5",
    "::-webkit-scrollbar": {
      width: "10px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f0f0f0",
      borderRadius: "10px",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#E5E5E5",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  card: {
    borderRadius: "8px",
    padding: ".5rem",
    backgroundColor: "#f5f5f5",
  },
  title: {
    borderRadius: "4px",
    padding: "0.3rem",
    borderLeftWidth: "5px",
    borderLeftStyle: "solid",
  },
  noteCardTitle: {
    backgroundColor: "#FEF0C7",
    borderLeftColor: "#CC7914",
  },
  taskCardTitle: {
    backgroundColor: "#F6F0FF",
    borderLeftColor: "#D6BEF5",
  },
  medicationCardTitle: {
    backgroundColor: "#DCFFCC",
    borderLeftColor: "#1EA736",
  },
  documentCardTitle: {
    backgroundColor: "#E0F4FF",
    borderLeftColor: "#1791D3",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: ".1rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "0.5rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "0.5rem",
  },
  taskCard: {
    borderRadius: "10px",
    padding: ".5rem",
    backgroundColor: "#f5f5f5",
  },
  taskCardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
  },
}));

export const PendingActionsHeader = ({
  classes,
  loading,
  count,
  actions = [],
}) => {
  const hasPending = count > 0 || actions?.length > 0;

  return (
    <Box className={classes?.header}>
      <Text ff="Inter" fz={18} fw={500} m={5}>
        Pending Actions
      </Text>

      {loading ? (
        <Skeleton w={32} h={32} radius="xl" color="gray" />
      ) : (
        hasPending && (
          <Badge
            color="red"
            size="xl"
            radius="xl"
            variant="filled"
            p="xs"
            h={32}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {count || 0}
          </Badge>
        )
      )}
    </Box>
  );
};

const PendingAction = () => {
  // const [docNotifications, setDocNotifications] = useState(null);
  // const { expiredFiles } = useSelector((state) => state?.document);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const [
    pendingActionDrawerOpened,
    { open: pendingActionDrawerOpen, close: pendingActionDrawerClose },
  ] = useDisclosure(false);

  const {
    dashboardPendingActions,
    dashboardPendingActionsLoading,
    dashboardPendingActionsCount,
  } = useSelector((state) => state?.dashboard);
  // const [sortedDashboardPendingNotes, setSortedDashboardPendingNotes] =
  //   useState([]);

  const { staff } = useSelector((state) => state.staff);
  // useEffect(() => {
  //   if (dashboardPendingNotes?.length) {
  //     let tempArr = [...dashboardPendingNotes].sort(
  //       (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
  //     );
  //     setSortedDashboardPendingNotes(tempArr);
  //   }
  // }, [dashboardPendingNotes]);

  // const numberOfPendingNotes = sortedDashboardPendingNotes?.length;

  const { classes, cx } = useStyles();

  // const { notifications } = useSelector((state) => state.notification);
  // const allNotifications = Object.values(notifications).flat();

  // // document map
  // const mappedDocumentNotifications = expiredFiles?.expiredFiles
  //   ?.filter((n) => {
  //     const isClientActive = n?.client ? n?.client?.active === true : true;
  //     const isStaffActive = n?.staff ? n?.staff?.active === true : true;

  //     return (
  //       n &&
  //       n?.expired !== false &&
  //       n?.deleted !== true &&
  //       isClientActive &&
  //       isStaffActive
  //     );
  //   })
  //   .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  //   .map((n) => {
  //     const { _id, message, facility, staff, client } = n;
  //     const userId = n?.client?.id || n?.staff?.id || n?.facility?.id;

  //     const name =
  //       n?.facility?.name ||
  //       (n?.client ? decrypt(n?.client?.name, false) : null) ||
  //       n?.staff?.name ||
  //       "";
  //     const fileName = n?.name || "";

  //     return {
  //       id: _id,
  //       message,
  //       ...n,
  //       name,
  //       userId,
  //       facility,
  //       staff,
  //       client,
  //       fileName,
  //     };
  //   });

  // const [pendingActions, setPendingActions] = useState([]);

  // useEffect(() => {
  //   const allNotifications = Object.values(notifications).flat();
  //   // const mappedDocumentNotifications = allNotifications
  //   const mappedDocumentNotifications = expiredFiles?.expiredFiles
  //     ?.filter((n) => {
  //       const isClientActive = n?.client ? n?.client?.active === true : true;
  //       const isStaffActive = n?.staff ? n?.staff?.active === true : true;
  //       return (
  //         n &&
  //         n?.expired !== false &&
  //         n?.deleted !== true &&
  //         isClientActive &&
  //         isStaffActive
  //       );
  //     })
  //     .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  //     .map((n) => {
  //       // const { _id, message, metadata, facility, staff, client } = n;
  //       const { _id, message, facility, staff, client } = n;
  //       // const { file, folder } = metadata;
  //       const userId = n?.client?.id || n?.staff?.id || n?.facility?.id;

  //       const name =
  //         n?.facility?.name ||
  //         (n?.client ? decrypt(n?.client?.name, false) : null) ||
  //         n?.staff?.name ||
  //         "";
  //       const fileName = n?.name || "";

  //       return {
  //         id: _id,
  //         message,
  //         ...n,
  //         name,
  //         userId,
  //         facility,
  //         staff,
  //         client,
  //         fileName,
  //       };
  //     });

  //   setDocNotifications(mappedDocumentNotifications);
  // }, [notifications, expiredFiles]);

  // useEffect(() => {
  //   if (dashboardPendingNotes?.length || docNotifications?.length) {
  //     const noteItems =
  //       dashboardPendingNotes?.map((item) => ({
  //         ...item,
  //         type: "note",
  //         createdAt: item?.noteDate || item?.createdAt,
  //       })) || [];

  //     const documentItems =
  //       docNotifications?.map((item) => ({
  //         ...item,
  //         type: "document",
  //         createdAt: item?.expiry || item?.createdAt, // adjust if expiry isn't accurate
  //       })) || [];

  //     const combined = [...noteItems, ...documentItems].sort(
  //       (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  //     );

  //     setPendingActions(combined);
  //   } else {
  //     setPendingActions([]);
  //   }
  // }, [dashboardPendingNotes, docNotifications]);

  const hasPermissions = profile?.user?.permissions;

  return (
    <Box className={classes.container}>
      <PendingActionsHeader
        classes={classes}
        loading={dashboardPendingActionsLoading}
        count={dashboardPendingActionsCount}
        actions={dashboardPendingActions}
      />
      {dashboardPendingActionsLoading ? (
        Array.from({ length: 5 }).map((_, index) => (
          <Skeleton
            key={index}
            mb="md"
            radius="md"
            height={400}
            color="gray"
            c={"#E5E5E5"}
            visible={true}
          />
        ))
      ) : dashboardPendingActions?.length > 0 ? (
        <>
          {dashboardPendingActions
            ?.filter((item) => {
              if (item.type === "document") return true;
              if (!hasPermissions) return true; // show notes if permission object doesn't exist
              return profile?.user?.permissions?.note === true;
            })
            ?.map((item, index) => {
              if (item?.type === "document") {
                return <DocumentNotificationCard key={item?.id} item={item} />;
              }
            })}
          <Button
            size="md"
            fullWidth
            c={"#000"}
            variant="white"
            onClick={pendingActionDrawerOpen}
          >
            View All
          </Button>
        </>
      ) : (
        <Text
          ff={"Inter"}
          fz={16}
          c={"#737373"}
          fw={500}
          align="center"
          my={"auto"}
        >
          No pending actions found.
        </Text>
      )}

      <PendingActionsDrawer
        opened={pendingActionDrawerOpened}
        close={pendingActionDrawerClose}
      />
    </Box>
  );
};

// const PendingAction = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedNote, setSelectedNote] = useState(null);

//   const { dashboardPendingNotes, dashboardPendingNotesLoading } = useSelector(
//     (state) => state?.dashboard
//   );

//   const { staff } = useSelector((state) => state.staff);

//   const staffInfo = staff?.staffs?.filter(
//     (item) =>
//       item?.id ===
//       dashboardPendingNotes?.map((item) => item?.fields?.["Staff Name"])?.[0]
//   );

//   const numberOfPendingNotes = dashboardPendingNotes?.length;

//   const { classes } = useStyles();
//   const icon = <TbFileUpload />;

//   return (
//     <Box className={classes.container}>
//       <Box className={classes.header}>
//         <Title order={3} m="md">
//           Pending Actions
//         </Title>
//         <Badge color="red" size="xl" radius="xl" variant="filled" circle>
//           {numberOfPendingNotes}
//         </Badge>
//       </Box>
//       {dashboardPendingNotesLoading ? (
//         // Array.from({ length: 3 }).map((_, index) => (
//         <Skeleton
//           mb="md"
//           radius="md"
//           height={400}
//           color="gray"
//           c={"#E5E5E5"}
//           visible={dashboardPendingNotesLoading}
//         />
//       ) : (
//         // ))
//         dashboardPendingNotes?.map((item, index) => (
//           <Box className={classes.card} key={index}>
//             <Box className={`${classes.title} ${classes.noteCardTitle}`}>
//               <Text ff={"Inter"} fz={20} fw={700}>
//                 {`${index + 1} Note`}
//               </Text>
//             </Box>
//             <Box className={classes.body}>
//               <Badge
//                 size="xl"
//                 radius="xl"
//                 color="gray"
//                 c={"#525252"}
//                 tt={"uppercase"}
//                 w={"fit-content"}
//               >
//                 {item?.fields?.noteType || item?.noteId?.name}
//               </Badge>
//               <Text ff={"Inter"} fz={30} fw={700}>
//                 {staffInfo?.map((item) => item?.name)?.[0]}
//               </Text>
//               <Text ff={"Inter"} fz={14} c={"#A3A3A3"} fw={500}>
//                 {moment(item?.noteDate || item?.createdAt).format(
//                   "MMM DD, hh:mmA"
//                 )}
//               </Text>
//               <Text ff={"Inter"} fz={14} c={"#737373"} fw={400}>
//                 {item?.fields?.Description || "No Description Found"}
//               </Text>

//               <Center>
//                 <Button
//                   fz={14}
//                   fw={500}
//                   fullWidth
//                   c={"#000"}
//                   ff={"Inter"}
//                   variant="white"
//                   onClick={() => {
//                     setSelectedNote(item);
//                     setIsOpen(true);
//                   }}
//                 >
//                   View Details
//                 </Button>
//                 {selectedNote && (
//                   <NoteModalNew
//                     view={true}
//                     opened={isOpen}
//                     data={selectedNote}
//                     title={"View Note"}
//                     close={() => setIsOpen(false)}
//                   />
//                 )}
//               </Center>
//             </Box>
//           </Box>
//         ))
//       )}
//       {/* <Box className={classes.card}>
//         <Box className={`${classes.title} ${classes.taskCardTitle}`}>
//           <Text ff={"Inter"} fz={20} fw={700}>
//             Task
//           </Text>
//         </Box>
//         <Box className={classes.body}>
//           <Text ff={"Inter"} fz={30} fw={700}>
//             Assisted Living
//           </Text>
//           <Box className={classes.taskCard}>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Client Name
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 Allan Smith
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Date created
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 07-11-2024
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Date remaining
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 24 days
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Shift
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 Morning
//               </Text>
//             </Box>
//           </Box>
//           <Center>
//             <TaskDrawer title="Task" />
//           </Center>
//         </Box>
//       </Box>
//       <Box className={classes.card}>
//         <Box className={`${classes.title} ${classes.medicationCardTitle}`}>
//           <Text ff={"Inter"} fz={20} fw={700}>
//             Medication
//           </Text>
//         </Box>
//         <Box className={classes.body}>
//           <Text ff={"Inter"} fz={30} fw={700}>
//             Castro Rodriguez
//           </Text>
//           <Box className={classes.taskCard}>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Medication Name
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 Gromatorin
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Refill Quantity
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 10
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Count after Refill
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 110
//               </Text>
//             </Box>
//             <Box className={classes.taskCardContent}>
//               <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//                 Refill Date
//               </Text>
//               <Text ff={"Inter"} fz={16} c={"#000"} fw={500}>
//                 07-1-2024
//               </Text>
//             </Box>
//           </Box>
//           <Center>
//             <Button variant="white" c={"#000"} ff={"Inter"} fz={14} fw={500}>
//               View Details
//             </Button>
//           </Center>
//         </Box>
//       </Box>
//       <Box className={classes.card}>
//         <Box className={`${classes.title} ${classes.documentCardTitle}`}>
//           <Text ff={"Inter"} fz={20} fw={700}>
//             Document
//           </Text>
//         </Box>
//         <Box className={classes.body}>
//           <Text ff={"Inter"} fz={30} fw={700}>
//             Castro Rodriguez
//           </Text>
//           <Text ff={"Inter"} fz={16} c={"#A3A3A3"} fw={500}>
//             Added a file
//           </Text>
//           <FileInput
//             variant="filled"
//             leftSection={icon}
//             placeholder="Document.PDF"
//             leftSectionPointerEvents="none"
//           />
//           <Center>
//             <Button variant="white" c={"#000"} ff={"Inter"} fz={14} fw={500}>
//               View Details
//             </Button>
//           </Center>
//         </Box>
//       </Box> */}
//     </Box>
//   );
// };

export default PendingAction;
